export const getShopDomain = state => state.shopDomain;
